export default __webpack_public_path__ + "static/media/warning-icon.33d59936.svg";